/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCrossRefAllocationCode.ts     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-cross-ref-allocation-code";

export class AutogenModelEdiCrossRefAllocationCode<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCrossRefAllocationCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCrossRefAllocationCode extends ModelRow<RowEdiCrossRefAllocationCodeFields> {
	constructor(values?: Partial<RowEdiCrossRefAllocationCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCrossRefAllocationCodeFields {
	company_id: string;
	edi_code: string;
	equipment_type_id: string;
	fgi_packaging_type_code: string;
	hdr_uid: number;
	id: string;
	la_business_unit: string;
	order_type_id: string;
	partner_id: string;
	revenue_code_id: string;
	seg_alloc_code: string;
	"seg_alloc_code.alloc_type": string;
	"seg_alloc_code.code": string;
	"seg_alloc_code.comments": string;
	"seg_alloc_code.company_id": string;
	"seg_alloc_code.descr": string;
	"seg_alloc_code.gl_seg_code_code1": string;
	"seg_alloc_code.gl_seg_code_code2": string;
	"seg_alloc_code.gl_seg_code_code3": string;
	"seg_alloc_code.gl_seg_code_code4": string;
	"seg_alloc_code.gl_seg_code_code5": string;
	"seg_alloc_code.is_active": string;
	version: string;
}

